import { z } from "zod";

export const cleanerDirectoryEntrySchema = z.strictObject({
  cleanerUserId: z.string().regex(/^[0-9a-f]{32}$/u),
  providerId: z.string().regex(/^[0-9a-f]{32}$/u),
  publicName: z.string().min(1),
  totalCancellations: z.number().int().min(0),
  recentCancellations: z.number().int().min(0),
});

export const cleanerSearchResponseSchema = z.strictObject({
  status: z.literal("ok"),
  cleaners: z.array(cleanerDirectoryEntrySchema),
});

export const cleanerMarketplaceEntrySchema = z.strictObject({
  cleanerUserId: z.string().regex(/^[0-9a-f]{32}$/u),
  providerId: z.string().regex(/^[0-9a-f]{32}$/u),
  publicName: z.string().min(1),
  totalCancellations: z.number().int().min(0),
  recentCancellations: z.number().int().min(0),
  averageRating: z.number().min(1).max(5).nullable(),
  reviewCount: z.number().int().min(0),
  lastSeenAt: z.string().datetime({ offset: true }).nullable(),
});

export const cleanerMarketplaceListResponseSchema = z.strictObject({
  status: z.literal("ok"),
  cleaners: z.array(cleanerMarketplaceEntrySchema),
});

export type CleanerDirectoryEntry = z.infer<typeof cleanerDirectoryEntrySchema>;
export type CleanerMarketplaceEntry = z.infer<typeof cleanerMarketplaceEntrySchema>;
